// Each site flies in along a curve, docks in its slot, then sends a pulse up the tree to the organization.
const NS = 'http://www.w3.org/2000/svg'
const DEVICE = '#organization-move-sites-device'
const SITES = [
  // Kept shallow: a deeper swoop drops below the drawing into whatever sits under it.
  {slot: [180, 192], from: [20, 206], via: [100, 214]},
  {slot: [96, 192], from: [-14, 150], via: [10, 236]},
  {slot: [264, 192], from: [374, 150], via: [350, 236]},
]
// LEAD holds the empty opening frame before the first one arrives.
const LEAD = 1
// HOLD keeps every site in place for a while before the scene fades and starts over.
const STEP = 2.3, FLY = 1.3, HOLD = 18.1, END = SITES.length * STEP + 1.3 + HOLD, CYCLE = LEAD + END + 1.1

const el = (tag, attrs, parent) => {
  const e = document.createElementNS(NS, tag)
  for (const k in attrs) e.setAttribute(k, attrs[k])
  parent.append(e)
  return e
}
const clamp = (x, a = 0, b = 1) => Math.min(b, Math.max(a, x))
const ease = t => t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2
const back = t => 1 + 2.7 * Math.pow(t - 1, 3) + 1.7 * Math.pow(t - 1, 2)

function build(root) {
  const part = name => root.querySelector(`.${name}`)
  const pulses = [...root.querySelectorAll('.tree .pulse')]

  const sites = SITES.map((site, i) => {
    const s = {...site}
    const [x, y] = s.slot
    s.slotEl = el('rect', {class: 'slot', x: x - 27, y: y - 31, width: 54, height: 62, rx: 6}, part('slots'))
    s.trail = el('path', {class: 'trail', pathLength: 1, d: `M${s.from}Q${s.via} ${s.slot}`}, part('trails'))
    s.dev = el('use', {href: DEVICE}, part('devices'))
    s.check = el('g', {}, part('checks'))
    el('circle', {r: 10, fill: '#3fae6a', stroke: '#fff', 'stroke-width': 2}, s.check)
    el('path', {d: 'M-4.2 0.3l3 3 5.4-6', fill: 'none', stroke: '#fff', 'stroke-width': 2.2, 'stroke-linecap': 'round', 'stroke-linejoin': 'round'}, s.check)
    s.pulse = pulses[i]
    return s
  })

  return {sites, org: part('org'), wins: [...root.querySelectorAll('.wins .win')]}
}

function draw({sites, org, wins}, t) {
  const fade = 1 - clamp((t - END) / 0.6)
  let glow = 0

  sites.forEach((s, i) => {
    const t0 = i * STEP, u = clamp((t - t0) / FLY), e = ease(u), q = 1 - e
    const x = q * q * s.from[0] + 2 * q * e * s.via[0] + e * e * s.slot[0]
    const y = q * q * s.from[1] + 2 * q * e * s.via[1] + e * e * s.slot[1]
    const dock = clamp((t - t0 - FLY) / 0.4), up = clamp((t - t0 - FLY - 0.1) / 0.7), tilt = (1 - e) * (s.from[0] < 180 ? -14 : 14)
    const seg = Math.min(0.3, e)

    s.dev.setAttribute('transform', `translate(${x.toFixed(2)} ${y.toFixed(2)}) rotate(${tilt.toFixed(1)}) scale(${(0.72 + 0.28 * e + 0.06 * Math.sin(dock * Math.PI)).toFixed(3)})`)
    s.dev.setAttribute('opacity', (clamp(u * 5) * fade).toFixed(3))
    s.trail.setAttribute('stroke-dasharray', `${seg} 2`)
    s.trail.setAttribute('stroke-dashoffset', -(e - seg))
    s.trail.style.opacity = (u > 0 ? 0.55 * (1 - clamp((u - 0.75) / 0.25)) : 0).toFixed(3)
    s.slotEl.style.stroke = dock > 0 ? '#3fae6a' : ''
    s.slotEl.style.strokeDasharray = dock > 0 ? 'none' : ''
    s.slotEl.style.opacity = dock > 0 ? fade : 1
    s.check.setAttribute('transform', `translate(${s.slot[0] + 22} ${s.slot[1] - 27}) scale(${(dock > 0 ? back(dock) * fade : 0).toFixed(3)})`)
    s.pulse.setAttribute('stroke-dasharray', '0.3 2')
    s.pulse.setAttribute('stroke-dashoffset', (0.3 - up * 1.3).toFixed(3))
    s.pulse.setAttribute('opacity', (up > 0 && up < 1 ? Math.sin(up * Math.PI) : 0).toFixed(3))
    glow = Math.max(glow, Math.sin(clamp((t - t0 - FLY - 0.65) / 0.5) * Math.PI))
  })

  org.setAttribute('transform', `translate(180 118) scale(${(1 + 0.045 * glow).toFixed(4)}) translate(-180 -118)`)
  wins.forEach((w, i) => {
    const twinkle = 0.55 + 0.25 * Math.sin(t * 1.3 + i * 2.1)
    w.setAttribute('opacity', Math.min(1, twinkle + glow * 0.6).toFixed(3))
    w.style.fill = glow > 0.05 ? `color-mix(in srgb, #3fae6a ${Math.round(glow * 70)}%, #3f7fd6)` : ''
  })
}

let Hooks = {}

Hooks['Animations.OrganizationMoveSites'] = {
  mounted() {
    const scene = build(this.el)

    // One site on its way in, held still.
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return draw(scene, 0.9)

    const start = performance.now()
    const frame = now => {
      draw(scene, ((now - start) / 1000) % CYCLE - LEAD)
      this.raf = requestAnimationFrame(frame)
    }
    this.raf = requestAnimationFrame(frame)
  },

  destroyed() {
    cancelAnimationFrame(this.raf)
  }
}

export {Hooks}
